import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { ChevronRightIcon, MapPin } from 'lucide-react'
import { useEnumsQuery } from '@/api/accommodation/hooks'
import { useSearchFilters } from './useSearchFilters'

function RegionFilterContent({ onOpenChange }: { onOpenChange?: (open: boolean) => void }) {
  const { localFilters, updateLocalFilters } = useSearchFilters()
  const { data: enums } = useEnumsQuery()

  return (
    <Select
      name="region"
      value={localFilters.region}
      onValueChange={(value) => updateLocalFilters({ region: value })}
      onOpenChange={onOpenChange}
    >
      <SelectTrigger id="region" className="h-10! w-full bg-slate-100 text-slate-900!">
        <div className="flex items-center gap-2">
          <MapPin className="text-red h-4 w-4" />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-[40vh]">
        <SelectItem key="all" value={'all'} className="px-4 py-2">
          Kamkoliv
        </SelectItem>
        {enums?.regions
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name, 'cs'))
          .map((region) => (
            <SelectItem key={region.id} value={region.slug} className="px-4 py-2">
              {region.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  )
}

interface RegionFilterMobileProps {
  onOpenRegionSelection?: () => void
}

export function RegionFilterMobile({ onOpenRegionSelection }: RegionFilterMobileProps) {
  const { localFilters } = useSearchFilters()
  const { data: enums } = useEnumsQuery()

  const selectedRegionName =
    localFilters.region === 'all'
      ? 'Kamkoliv'
      : enums?.regions.find((r) => r.slug === localFilters.region)?.name || 'Kamkoliv'

  return (
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-slate-800">Kam</span>
      <Button
        variant="ghost"
        className="flex h-auto items-center gap-1 font-normal text-slate-600"
        onClick={onOpenRegionSelection}
      >
        {selectedRegionName}
        <ChevronRightIcon className="mt-1" />
      </Button>
    </div>
  )
}

interface RegionSelectionMobileProps {
  onSelect: () => void
}

export function RegionSelectionMobile({ onSelect }: RegionSelectionMobileProps) {
  const { localFilters, updateLocalFilters } = useSearchFilters()
  const { data: enums } = useEnumsQuery()

  const handleSelect = (value: string) => {
    updateLocalFilters({ region: value })
    onSelect()
  }

  const regions = [
    { slug: 'all', name: 'Kamkoliv' },
    ...(enums?.regions
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name, 'cs'))
      .map((r) => ({ slug: r.slug, name: r.name })) ?? []),
  ]

  return (
    <div className="flex max-h-[60vh] flex-col gap-1 overflow-y-auto">
      {regions.map((region) => (
        <Button
          key={region.slug}
          variant="ghost"
          className="-ml-2 justify-between px-2 text-left text-lg text-slate-800"
          onClick={() => handleSelect(region.slug)}
        >
          <span className={`${localFilters.region === region.slug ? 'font-semibold' : 'font-normal'}`}>
            {region.name}
          </span>
          {/* {localFilters.region === region.id && (
            <CheckIcon className="h-8 w-8 text-green-600" />
          )} */}
        </Button>
      ))}
    </div>
  )
}

export function RegionFilterDesktop() {
  const { commitFilters } = useSearchFilters()

  return (
    <div className="flex grow basis-0 flex-col gap-1">
      <label htmlFor="region" className="text-sm text-slate-400">
        Lokalita
      </label>
      <RegionFilterContent
        onOpenChange={(open) => {
          if (!open) commitFilters()
        }}
      />
    </div>
  )
}
